import { Modal, Typography } from "@material-ui/core";
import { Button, Stack } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { color } from "../../assets/const/color";

import { useStyles } from "./styles";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: color.white,
  borderRadius: "25px",
  p: 4,
};

const DeleteModal = (props) => {
  const { setOpen, open, deleteAction, active, textmsg, component, status } =
    props;
  const classes = useStyles();
  const handleClose = () => setOpen(false);
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className={classes.root}
    >
      <Box sx={style}>
        <Typography>{textmsg}</Typography>
        <Stack sx={{ flexDirection: "row", justifyContent: "flex-end", mt: 2 }}>
          <Button
            className={classes.yes_btn}
            onClick={() => {
              if (component === "course") {
                deleteAction({ id: active, status });
                handleClose();
              } else if (component === "student") {
                deleteAction({
                  deleteStudentInfo: {
                    idStudent: active,
                    status,
                  },
                });
                handleClose();
              } else if (component === "staff") {
                deleteAction({
                  deleteFacultyInfo: {
                    idFaculty: active,
                    status,
                  },
                });
                handleClose();
              } else if (component === "arrival") {
                deleteAction({
                  libraryBooks: {
                    id: active,
                    status,
                  },
                });
                handleClose();
              } else if (component === "classes") {
                deleteAction({
                  id: active,
                  status,
                });
                handleClose();
              } else if (component === "institution") {
                deleteAction({
                  id: active,
                  status,
                });
                handleClose();
              }
            }}
          >
            Yes
          </Button>
          <Button className={classes.no_btn} onClick={() => handleClose()}>
            No
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default DeleteModal;
